import { type GA4 } from "./interfaces";

/**
 * When a user is presented with a list of results, send a view_item_list event including an items array parameter containing the displayed items.
 * @param payload
 */
export async function sendViewItemListDatalayerEvent(
  payload: GA4.ViewItemListPayload,
) {
  window.gtag({ ecommerce: null });

  window.gtag({
    event: "view_item_list",
    ecommerce: payload,
  });
}
